import * as def from '@/definitions'
import { PatternBaseLayer } from './patternBaseLayer'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { PathHelper } from '@/helper/pathHelper';
import { DebugHelper } from '@/helper/debugHelper';

// 特殊図形レイヤー
export class SpecialPatternLayer extends PatternBaseLayer
{
    public get layerType() : string { return "specialPattern"; }
    // 図形種別
    private _patternType : string = "";
    public get patternType() { return this._patternType; }
    public set patternType(patternType : string) { this._patternType = patternType; }

    // パス(SVG形式)
    private _path : string = "";
    public get path() : string { return this._path; }
    public set path(path : string) { this._path = path; }

    // 多角形点
    private _polygonPoints : string = "";
    public get polygonPoints() : string { return this._polygonPoints; }
    public set polygonPoints(polygonPoints : string) { this._polygonPoints = polygonPoints; }

    // パスの変形情報
    private _translateX : number = 0;
    public get translateX() : number { return this._translateX; }
    public set translateX(translateX : number) { this._translateX = translateX; }
    private _translateY : number = 0;
    public get translateY() : number { return this._translateY; }
    public set translateY(translateY : number) { this._translateY = translateY; }

    // パスのベースサイズ
    private _baseWidth : number = 1;
    public get baseWidth() : number { return this._baseWidth; }
    public set baseWidth(baseWidth : number) { this._baseWidth = baseWidth; }
    private _baseHeight : number = 1;
    public get baseHeight() : number { return this._baseHeight; }
    public set baseHeight(baseHeight : number) { this._baseHeight = baseHeight; }

    // 作成
    public static create(type : string, autoHeight : boolean, x : number = 0, y : number = 0, width : number = 0, height : number = 0) : SpecialPatternLayer
    {
        var layer = new SpecialPatternLayer();
        layer.keepRatio = 0;
        layer.strokeColor = new ColorConstruct(0, 0, 0);
        layer.strokeWidth = 1.0;
        layer.fillType = 0;
        layer.fillColor = new ColorConstruct(51 ,153, 0);
        layer.rotate = 0;
        layer.width = width;
        layer.height = height;
        layer.x = x;
        layer.y = y;

        // 初期グラデーション
        layer.addGradation(0, new ColorConstruct(0, 255, 0));
        layer.addGradation(100, new ColorConstruct(255, 255,255));
        layer.linearGradationAngle = 0;

        // パス
        layer.patternType = type;
        var info = PathHelper.createSpecialPattern(type);
        DebugHelper.trace(type);
        layer.path = info.path;
        layer.polygonPoints = info.polygon;
        layer.translateX = info.translateX;
        layer.translateY = info.translateY;
        layer.baseWidth = info.baseWidth;
        layer.baseHeight = info.baseHeight;

        if(autoHeight)
        {
            // 自動高さ調整
            layer.height = layer.width * info.baseHeight / info.baseWidth;
            if(layer.height != height)
            {
                // y位置調整
                layer.y += (height - layer.height) / 2;
            }
        }
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new SpecialPatternLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : SpecialPatternLayer)
    {
        layer.patternType = this._patternType;
        layer.path = this._path;
        layer.polygonPoints = this._polygonPoints;
        layer.translateX = this.translateX;
        layer.translateY = this.translateY;
        layer.baseWidth = this._baseWidth;
        layer.baseHeight = this._baseHeight;
        
        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.patternType = this._patternType;
        jsonObject.path = this._path;
        jsonObject.polygonPoints = this._polygonPoints;
        jsonObject.translateX = this._translateX;
        jsonObject.translateY = this._translateY;
        jsonObject.baseWidth = this._baseWidth;
        jsonObject.baseHeight = this._baseHeight;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : SpecialPatternLayer
    {
        var layer = new SpecialPatternLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.patternType != null) { this._patternType = jsonData.patternType; }
        if(jsonData.path != null) { this._path = jsonData.path; }
        if(jsonData.polygonPoints != null) { this._polygonPoints = jsonData.polygonPoints; }
        if(jsonData.translateX != null) { this._translateX = jsonData.translateX; }
        if(jsonData.translateY != null) { this._translateY = jsonData.translateY; }
        if(jsonData.baseWidth != null) { this._baseWidth = jsonData.baseWidth; }
        if(jsonData.baseHeight != null) { this._baseHeight = jsonData.baseHeight; }

        super.loadParameterFromJson(jsonData);
    }
}